import { Link } from 'gatsby';
import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import ElementAlert from 'src/components/ElementAlert/ElementAlert';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import { DesktopUp } from 'src/utils/breakpoints';
import { useLottieAnimation } from '../../../hooks/useLottieAnimation';
import * as classes from './ContactFormWithAnimation.module.scss';
import useForm from 'src/hooks/useContactForm';
import useTheme from 'src/hooks/useTheme';

export const ContactFormWithAnimation = ({ animationData, fallbackImage, header }) => {
  const { Animation } = useLottieAnimation({ animationData, fallbackImage });
  const t = useTheme();

  const formElements = [
    { name: 'name', label: t.form.name, type: 'text', required: true },
    { name: 'email', label: t.form.email, type: 'email', required: true },
    {
      name: 'message',
      label: t.form.message,
      type: 'text',
      required: true,
      as: 'textarea',
      rows: 5,
    },
    {
      name: 'privacy_policy-animation',
      type: 'checkbox',
      custom: true,
      required: true,
      label: (
        <span className="text-size-sm text-white">
          <span className="mr-1">{t.form.gdprConsent}</span>
          <Link to={`/${t.navigation.gdpr.path}`} className="text-secondary font-weight-semi-bold">
            {t.navigation.gdpr.label}
          </Link>
        </span>
      ),
    },
  ];

  const initialValues = {
    name: '',
    email: '',
    message: '',
    'privacy_policy-animation': false,
    webform_id: 'contact_us',
  };

  const { formik, isSubmitting, error } = useForm({ initialValues });

  return (
    <Container fluid className="bg-gray-800 px-0 py-6">
      <Container>
        <Row>
          {animationData && (
            <DesktopUp>
              <Col xs={{ span: 6, offset: -2 }} className={classes.animationWrapper}>
                <Animation />
              </Col>
            </DesktopUp>
          )}
          <Col xs={12} lg={animationData ? 6 : { span: 8, offset: 2 }} xl={animationData ? 6 : { span: 6, offset: 3 }}>
            <Row>
              <Col xs={12} className="text-center">
                <PortableHeader className="text-white" content={header} />
              </Col>
            </Row>
            <Form onSubmit={formik.handleSubmit}>
              {formElements.map((e) => {
                switch (e.type) {
                  case 'checkbox':
                    return (
                      <Form.Group key={e.name} controlId={e.name} className="mb-4">
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            type="checkbox"
                            id={e.name}
                            name={e.name}
                            checked={formik.values[e.name]}
                            onChange={formik.handleChange}
                            required={e.required}
                          />
                          <label className="custom-control-label" htmlFor={e.name}>
                            {e.label}
                          </label>
                        </div>
                      </Form.Group>
                    );
                  default:
                    return (
                      <Form.Group key={e.name} controlId={e.name} className="mb-3">
                        <Form.Label>{e.label}</Form.Label>
                        <Form.Control {...e} placeholder={e.label} value={formik.values[e.name]} onChange={formik.handleChange} />
                      </Form.Group>
                    );
                }
              })}

              <div className="d-flex justify-content-center mt-8">
                <Button variant="gradient-secondary" type="submit" disabled={isSubmitting}>
                  {t.form.submit}
                  {isSubmitting && <span> ...</span>}
                </Button>
              </div>
            </Form>

            {error && (
              <ElementAlert
                variant="danger"
                title={t.form.confirmation.errorTitle}
                description={t.form.confirmation.errorDescription}
                className="animate-up mt-6"
              />
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ContactFormWithAnimation;
